import countryConfig from '@countryConfig/index';

import { commonConfig } from './common';
import { StaticConfig } from './staticTypes';

export const staticConfig: StaticConfig = {
    ...commonConfig,
    countrySpecific: countryConfig,
};
